export default "__VITE_ASSET__CjhJBNOb__"